import {
  Component,
  Input,
  OnInit,
  TemplateRef,
} from '@angular/core';

import { RouterHelperService } from '../../../services/router-helper.service';
import { IPreviousRoute } from '../../../models/route.model';


@Component({
    selector: 'canvas-admin-page-container',
    templateUrl: './page-container.component.html',
    styleUrls: ['./page-container.component.scss'],
    standalone: false
})
export class PageContainerComponent implements OnInit {

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor(private previousRouteService: RouterHelperService) {}

  private previousRoute?: IPreviousRoute;

  @Input() showContent: boolean | undefined = undefined;
  @Input() title: string | undefined = undefined;
  @Input() showBackLink = false;
  @Input() hasFilterBar = false;
  @Input() hasButtons = false;
  @Input() previousPageName?: string;
  @Input() centerTitle = false;
  @Input() breadCrumb: TemplateRef<unknown> | null = null;
  @Input() status? = '';

  ngOnInit(): void {
    this.previousPageName = this.previousPageName ? this.previousPageName : this.previousRouteService.previousRouteInfo?.name;
  }

  get backLinkText() {
    let suffix = 'previous page';
    if (this.previousPageName) {
      suffix = this.previousPageName;
    }
    return `Back to ${suffix.toLowerCase()}`;
  }

  back() {
    this.previousRouteService.goBack();
  }
 }
